import Template40 from './Template40.svelte';

export default class TaskGroup extends BaseView {
    initialize({
        model,
        task_view
    }) {

        // To use the newer Svelte technology, create a proxy backbone view.
        // which has all the methods of a backbone view, but proxies the most
        // important methods to the svelte view.
        const svelteView = this.addSvelteChildView(
            this.$el,
            Template40,
            {
                model,
                response: task_view.response,
                syncResponse: task_view.saveResponse.bind(task_view)
            }
        );

        const methodsToProxy = [
            'showAnswer', 'showAuthorAnswer', 'hideAnswer', 'lockAnswer',
            'unlockAnswer', 'getCorrectAnswer', 'getStudentAnswer'
        ]

        for (const method of methodsToProxy) {
            this[method] = svelteView[method].bind(svelteView);
        }
    }
}
